import { Search, X } from 'lucide-react';
import { cn } from '@/lib/cn';

export function SearchBox({ value, onChange, placeholder, className, autoFocus }: {
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
  className?: string;
  autoFocus?: boolean;
}) {
  return (
    <div className={cn('flex h-9 items-center gap-2 rounded-lg border border-line bg-surface px-3 transition-colors hover:border-line-strong focus-within:border-accent focus-within:ring-2 focus-within:ring-accent/25', className)}>
      <Search size={15} className="shrink-0 text-faint" />
      <input
        type="search"
        value={value}
        autoFocus={autoFocus}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        className="h-full min-w-0 flex-1 bg-transparent text-sm text-ink outline-none [&::-webkit-search-cancel-button]:hidden"
      />
      {value && (
        <button type="button" onClick={() => onChange('')} aria-label="Очистить" className="text-faint hover:text-ink"><X size={14} /></button>
      )}
    </div>
  );
}
